/* 🤖 this file was generated by svg-to-ts*/
export const icoArchive: {
  name: 'archive';
  data: string;
} = {
  name: 'archive',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 2a2 2 0 011.994 1.85L22 4v3a2 2 0 01-1.85 1.995L20 9v11a2 2 0 01-1.85 1.994L18 22H6a2 2 0 01-1.995-1.85L4 20V9a2 2 0 01-1.995-1.85L2 7V4a2 2 0 011.85-1.995L4 2h16zm-2 7H6v11h12V9zm-4 7a1 1 0 01.117 1.993L14 18h-4a1 1 0 01-.117-1.993L10 16h4zm6-12H4v3h16V4z" fill="#909090"/></svg>`
};
